import Footer from "./Footer";
import MainAfroPop from "./Main/MainAfroPop";
import Header from "./Header";

function AfroPop(params) {
  return (
    <div>
      <Header />
      <MainAfroPop />
      <Footer />
    </div>
  );
}
export default AfroPop;
